import { useAtom } from 'jotai';

import { tournamentAtom } from '@/store';
import { TournamentTeams, TournamentStatus } from '@/types';

type TournamentData = {
  tournamentStatus: TournamentStatus[];
  tournamentTeams: TournamentTeams[];
};

export const useTournament = () => {
  const [tournamentMap, setTournamentMap] = useAtom(tournamentAtom);

  const handleSetTournamentMaps = (data: TournamentData) => {
    const tournamentTeamsMap = new Map<number, TournamentTeams>();
    const tournamentStatusMap = new Map<number, TournamentStatus>();

    data.tournamentTeams.forEach((obj) => {
      tournamentTeamsMap.set(obj.id, obj);
    });

    data.tournamentStatus.forEach((obj) => {
      tournamentStatusMap.set(obj.id, obj);
    });

    setTournamentMap({
      tournamentTeamsMap,
      tournamentStatusMap,
    });
  };

  return { tournamentMap, handleSetTournamentMaps };
};
